import './nuveiStyle.css';

import { CreditCardFieldsIds } from '@src/clients/financialSettings/hooks/useNuveiCreditCardForm';
import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';

export const NuveiForm = () => {
  const gap = theme.spacing['3'];

  return (
    <Stack gap={gap}>
      <div id={CreditCardFieldsIds.CardNumber} className="input" />
      <Stack direction="row" gap={gap}>
        <div id={CreditCardFieldsIds.ExpirationDate} className="input" />
        <div id={CreditCardFieldsIds.CVV} className="input" />
      </Stack>
    </Stack>
  );
};
